import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import { send } from "emailjs-com";

const heroStyle = {
  paddingTop: 64,
  paddingBottom: 80,
  background:
    "linear-gradient(0deg, rgba(0,0,0,0.48), rgba(0,0,0,0.35)), url('https://res.cloudinary.com/american-legacy-tours/image/upload/f_auto,q_auto/img/shop') no-repeat center center",
  backgroundSize: "cover",
};

const inputStyle = {
  width: "100%",
  padding: "11px 14px",
  border: "1px solid rgba(255,255,255,0.3)",
  borderRadius: 4,
  background: "rgba(255,255,255,0.9)",
  fontSize: "0.97rem",
  fontFamily: "Montserrat, sans-serif",
  marginBottom: 12,
  outline: "none",
  boxSizing: "border-box",
};

const Contact = () => {
  const [sent, setSent] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);
  const [toSend, setToSend] = React.useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    send("service_thlhokp", "template_a5nz49a", toSend, "pspiVumi2F-ZjP1oN")
      .then(() => { setIsSent(true); })
      .catch(() => { setIsSent(false); setSent(false); });
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  return (
    <>
      <PageSEO
        title="Contact Us | American Legacy Tours"
        description="Get in touch with American Legacy Tours in Cincinnati, OH. Call (859) 951-8560, email us, or send a message. We're happy to help you book or answer any questions."
        path="/contact-us"
      />
      <div style={heroStyle}>
        <Container>
          <h2
            style={{
              color: "#fff",
              fontWeight: 800,
              fontSize: "clamp(1.6rem, 4vw, 2.4rem)",
              marginBottom: 32,
              textShadow: "1px 2px 8px rgba(0,0,0,0.5)",
            }}
          >
            Get in Touch
          </h2>

          <Row>
            <Col md={5} xs={12} className="mb-4 mb-md-0">
              <div className="glass-card" style={{ height: "100%" }}>
                <h4 style={{ fontWeight: 700, marginBottom: 8 }}>Address</h4>
                <p style={{ marginBottom: 20 }}>
                  1332 Vine St
                  <br />
                  Cincinnati, OH 45202
                </p>
                <hr />
                <h4 style={{ fontWeight: 700, marginBottom: 8 }}>Phone</h4>
                <p style={{ marginBottom: 20 }}>
                  <a href="tel:8599518560" style={{ fontWeight: 600 }}>(859) 951-8560</a>
                </p>
                <hr />
                <h4 style={{ fontWeight: 700, marginBottom: 8 }}>Email</h4>
                <p style={{ marginBottom: 0 }}>
                  <a
                    href="mailto:questions@americanlegacytours.com"
                    style={{ fontWeight: 600, wordBreak: "break-all" }}
                  >
                    questions@americanlegacytours.com
                  </a>
                </p>
              </div>
            </Col>

            <Col md={7} xs={12}>
              <div className="glass-card">
                <h4 style={{ fontWeight: 700, marginBottom: 20 }}>Send Us a Message</h4>
                <form onSubmit={onSubmit}>
                  <input
                    type="text"
                    name="from_name"
                    placeholder="Your Name"
                    value={toSend.from_name || ""}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                  <input
                    type="email"
                    name="reply_to"
                    placeholder="Your Email"
                    value={toSend.reply_to || ""}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                  <input
                    type="tel"
                    name="from_phone"
                    placeholder="Your Phone (optional)"
                    value={toSend.from_phone || ""}
                    onChange={handleChange}
                    style={inputStyle}
                  />
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    value={toSend.message || ""}
                    onChange={handleChange}
                    required
                    rows={5}
                    style={{ ...inputStyle, resize: "vertical", marginBottom: 16 }}
                  />
                  {!sent && (
                    <button type="submit" className="btn-brand" style={{ width: "100%", fontSize: "1rem" }}>
                      Send Message
                    </button>
                  )}
                  {isSent && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "16px",
                        background: "#e8f5e9",
                        borderRadius: 4,
                        color: "#2e7d32",
                        fontWeight: 600,
                      }}
                    >
                      Message sent! We'll be in touch soon.
                    </div>
                  )}
                </form>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 32 }}>
            <Col xs={12}>
              <iframe
                title="googlemap"
                width="100%"
                height="400"
                frameBorder="0"
                style={{ border: "none", borderRadius: 8, display: "block" }}
                src={
                  "https://www.google.com/maps/embed/v1/place?q=" +
                  encodeURI("1332 Vine St Cincinnati OH 45202") +
                  "&key=AIzaSyAF0pVwRqx_wSImGwi80X7chUgzKdq1Q_E"
                }
                allowFullScreen
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Contact;
